import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RequestService } from 'src/app/shared/services/request/request.service';

@Injectable({
  providedIn: 'root',
})
export class FiltroBuscaService {
  constructor(private _requestService: RequestService) {}

  buscarFiltroTiposObras(): Observable<any> {
    return this._requestService.requestMethod(
      `work/Search/RealEstate/Filter/ListTypeWork`,
      'GET',
      true,
    );
  }

  buscarFiltroPadraoObra(): Observable<any> {
    return this._requestService.requestMethod(
      `work/Search/RealEstate/Filter/ListPatternWork`,
      'GET',
      true,
    );
  }

  buscarFiltroFaseDaObra(): Observable<any> {
    return this._requestService.requestMethod(
      `work/Search/RealEstate/Filter/ListPhaseWork`,
      'GET',
      true,
    );
  }

  buscarFiltroEstados(): Observable<any> {
    return this._requestService.requestMethod(
      `work/Search/RealEstate/Filter/ListStateWork`,
      'GET',
      true,
    );
  }

  buscarCadastradaEm(): Observable<any> {
    return this._requestService.requestMethod(
      `work/Search/RealEstate/Filter/ListDateRegistered`,
      'GET',
      true,
    );
  }

  listaBuscasSalvas(): Observable<any> {
    return this._requestService.requestMethod(
      `work/Search/RealEstate/ListSavedSearches`,
      'GET',
      true,
      null,
    );
  }

  filtroTiposObras(idSelecionado: number | null): Observable<any> {
    const url = `work/Search/IndustrialBuildingsInfrastructure/WorkType?moduleID=${idSelecionado}`;
    return this._requestService.requestMethod(url, 'GET', true);
  }

  filtroDetalhesDaObra(idSelecionado: number | null): Observable<any> {
    const url = `work/Search/IndustrialBuildingsInfrastructure/WorkInfo?moduleID=${idSelecionado}`;
    return this._requestService.requestMethod(url, 'GET', true);
  }

  filtroCadastradaEm(idSelecionado: number | null): Observable<any> {
    const url = `work/Search/IndustrialBuildingsInfrastructure/DateRegistered?moduleID=${idSelecionado}`;
    return this._requestService.requestMethod(url, 'GET', true);
  }

  filtroSetorDaObra(idSelecionado: number): Observable<any> {
    const url = `work/Search/IndustrialBuildingsInfrastructure/WorkSector?moduleID=${idSelecionado}`;
    return this._requestService.requestMethod(url, 'GET', true);
  }

  filtroRegiaoIndustrial(): Observable<any> {
    const url = `work/Search/IndustrialBuildingsInfrastructure/Regions`;
    return this._requestService.requestMethod(url, 'GET', true);
  }

  filtroCronograma(idSelecionado: number): Observable<any> {
    const url = `work/Search/IndustrialBuildingsInfrastructure/WorkSchedule?moduleID=${idSelecionado}`;
    return this._requestService.requestMethod(url, 'GET', true);
  }

  listaBuscasSalvasIndustrial(idSelecionado: number): Observable<any> {
    const url = `work/Search/IndustrialBuildingsInfrastructure/ListSavedSearches?moduleID=${idSelecionado}`;
    return this._requestService.requestMethod(url, 'GET', true);
  }

  salvarBusca(data): Observable<any> {
    const url = `work/Search/IndustrialBuildingsInfrastructure/SaveWorkSearch`;
    return this._requestService.requestMethod(url, 'POST', true, data);
  }

  resultadoBuscaSalvaIndustrial(
    buscaID: number,
    idSelecionado: number,
  ): Observable<any> {
    return this._requestService.requestMethod(
      `work/Search/IndustrialBuildingsInfrastructure/SavedSearch/Filters?searchId=${buscaID}&moduleID=${idSelecionado}`,
      'GET',
      true,
      null,
    );
  }

  filterIndustrialBuildingsInfrastructure(data): Observable<any> {
    const url = `work/Search/IndustrialBuildingsInfrastructure/ListWork/Filter`;
    return this._requestService.requestMethod(url, 'POST', true, data);
  }
}
